export default {
  title: 'Add partner',
  mode: {
    single: 'Single partner',
    bulk: 'Bulk (CSV)',
  },
  buttons: {
    send_invite: 'Send invite',
  },
  bulk: {
    form: {
      file: {
        label: 'Partner list (CSV)',
        hint: 'One partner per row. Required columns: Email, Company country, and Registered company name or Company name. Brand name is optional and becomes the consumer display name. Every row is validated before anything is created.',
      },
    },
    buttons: {
      select_file: 'Select CSV file',
      download_template: 'Download import template',
      import: 'Import partners',
    },
    columns: {
      legal_name: 'Registered company name / Company name',
      display_name: 'Brand name',
      admin_email: 'Email',
      company_country: 'Company country',
    },
    errors: {
      title: 'The file could not be imported.',
      nothing_imported: 'No partner was created. Fix the rows above and upload the file again.',
      columns: {
        row: 'Row',
        column: 'Column',
        error: 'Error',
      },
    },
    toasts: {
      queued_one:
        '{{count}} partner queued — invites are sent as each one is created. You will get a summary email when the import finishes.',
      queued_other:
        '{{count}} partners queued — invites are sent as each one is created. You will get a summary email when the import finishes.',
    },
    footnote:
      'Partners are created one by one in the background with the same setup as a single partner: invite email, dashboard subdomain and default shop domain. The country decides currency and timezone; a state can be set later from the partner profile. Payment processing is configured afterwards on each partner’s Payments tab.',
  },
  form: {
    name: {
      label: 'Partner name',
    },
    admin_email: {
      label: 'Admin email (invite recipient)',
      hint: "We'll email an invite to set up their account.",
    },
    display_name: {
      label: 'Consumer display name',
      hint: 'The "Powered by ___" label shown to customers. Defaults to the partner name if left blank.',
    },
    region: {
      label: 'Country',
      placeholder: 'Select a country',
      hint: 'Sets the partner’s currency, timezone and invite language.',
      summary: 'Currency {{currency}} · {{timezone}} · Invite language {{language}}',
      default_root: 'Shop domain: new brands are served on {{host}}',
    },
    sub_region: {
      label: 'State',
      placeholder: 'Whole country',
      hint: 'Optional — leave empty to apply to the whole country.',
    },
    language: {
      label: 'Invite language',
      placeholder: '{{language}} (default)',
      hint: 'Optional — defaults to the country’s primary language.',
    },
  },
  footnote: 'Branding and earning settings can be configured after the partner accepts their invite.',
  toasts: {
    created: 'Partner created — the invite email is on its way.',
  },
};
